// src/ItmVrntPkgSuplrsPriceForm.js ver 01c  Jan 22 2026 6:11pm - SB120A3
// src/ItmVrntPkgSuplrsPriceForm.js ver 01b  Jan 22 2026 12:41pm - SB120A2
// src/ItmVrntPkgSuplrsPriceForm.js ver 01a  Jan 22 2026 11:33am - SB120A1
// src/ItmVrntPkgSuplrsPriceForm.js ver 01  Jan 21 2026 10:45am - SB120A
// src/ItmVrntPkgSuplrsPriceForm.js ver 00 Jan 16 2026 3:21am - SB120a
// src/ItmVrntPkgSuplrsPriceForm.js ver 00 Jan 15 2026 12:11pm - SB120
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useAuth } from './App';
import * as itmVrntPkgSuplrsPriceService from './api/itmVrntPkgSuplrsPriceService';
// UPDATED: Import from itemVariantsService
import * as itemVariantsService from './api/itemVariantsService'; // To fetch active item variant packages
import * as itemVariantPackageService from './api/itemVariantPackageService'; // DELETE corrected by AI Studio
import * as supplierService from './api/supplierService'; // To fetch active suppliers
import { ApiError } from './api/apiClient';

const initialItmVrntPkgSuplrsPriceState = {
    ItmVrntPkgName: '',
    SupplierCode: '',
    Price: 0.00,
    PkgToItmUOMFactor: 1.00, // Initial value 1.00
    // Computed fields will not be in state as they are derived
    // System fields also not in state as they are backend managed
    SKU: '', // Will be user modifiable in edit mode
    UPC: '', // Will be user modifiable in edit mode
    ChefsRating: '3-Good quality', // From ItemVariantPackage
    ChefsNotes: '', // From ItemVariantPackage
    PkgQty: 0, // From ItemVariantPackage
    PkgUOM: '', // From ItemVariantPackage
    Status: 'Active', // Default status
};

// Allowed dropdown options (from other modules or specific for this module)
const allowedChefsRatings = ['1-Exceptional quality', '2-Observably Better', '3-Good quality', '4-Just below good but okay', '5-Questionable to Poor'];
const allowedItemVariantPackageStatuses = ['Active', 'Not-Active'];


function ItmVrntPkgSuplrsPriceForm() {
    // const { tenantId, id: itmVrntPkgSupPriceId, mode } = useParams();
    const { id: itmVrntPkgSupPriceId, mode } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const auth = useAuth();

    const [formData, setFormData] = useState(initialItmVrntPkgSuplrsPriceState);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [generatedRecordNameError, setGeneratedRecordNameError] = useState(null);
    const [itmVrntPkgNameError, setItmVrntPkgNameError] = useState(null);
    const [supplierCodeError, setSupplierCodeError] = useState(null);
    const [priceError, setPriceError] = useState(null);
    const [uomFactorError, setUomFactorError] = useState(null);
    const [skuError, setSkuError] = useState(null);
    const [upcError, setUpcError] = useState(null);

    const [itemVariantPackageOptions, setItemVariantPackageOptions] = useState([]); // For ItmVrntPkgName dropdown
    const [supplierCodeOptions, setSupplierCodeOptions] = useState([]); // For SupplierCode dropdown

    // Computed fields for display only
    const [pkgQty, setPkgQty] = useState(0);
    const [pkgUOM, setPkgUOM] = useState('');
    const [pkgPricePerPkgUOM, setPkgPricePerPkgUOM] = useState(0.0000);
    const [pkgPricePerItmUOM, setPkgPricePerItmUOM] = useState(0.0000);
    const [chefsRating, setChefsRating] = useState('3-Good quality');
    const [chefsNotes, setChefsNotes] = useState('');

    const [sku, setSKU] = useState(''); // NEW ver 01: SKU is derived, not in formData
    const [upc, setUPC] = useState(''); // NEW ver 01: UPC is derived, not in formData
    const [status, setStatus] = useState('Active'); // NEW ver 01: Status is derived, not in formData
    const [isDataCurrent, setIsDataCurrent] = useState(true); // NEW ver 01: IsDataCurrent is derived, not in formData

    const [originalPrice, setOriginalPrice] = useState(0.00); // NEW ver 01: Store original price for comparison
    const [originalUOMFactor, setOriginalUOMFactor] = useState(1.00); // NEW ver 01a: Store original UOM Factor
    const [isEditingPrice, setIsEditingPrice] = useState(false); // NEW ver 01a: State for price edit mode

    // const isAdding = mode === 'add' || (!itmVrntPkgSupPriceId && !mode);
    // const isEditing = mode === 'edit';
    // const isShowingDetails = mode === 'details';

    const isEditing = Boolean(itmVrntPkgSupPriceId) && !location.pathname.includes('/itm-vrnt-pkg-suplrs-price/details/');
    const isShowingDetails = Boolean(itmVrntPkgSupPriceId) && location.pathname.includes('/itm-vrnt-pkg-suplrs-price/details/');
    const isAdding = !isEditing && !isShowingDetails; // Is adding if no siteId and not in details mode



    const canEdit = auth.userProfile?.TenantProfileEditor === true;

    // Helper to construct ItnVrntPkgSupplierRecordName (Memoized)
    const constructItnVrntPkgSupplierRecordName = useCallback((itmVrntPkgName, supplierCode) => {
        if (!itmVrntPkgName || !supplierCode) return '';
        return `${itmVrntPkgName}&${supplierCode}`.replace(/ /g, '_').toUpperCase();
    }, []);

    const tenantId = auth.userProfile?.SubsCoDocId; // re-added ver01. existing in ver 00a


    // Auto-compute derived values and update generated name on frontend for display
    useEffect(() => {
        // Compute PkgPricePerPkgUOM and PkgPricePerItmUOM
        const currentQty = pkgQty;
        const currentPrice = parseFloat(formData.Price);
        const currentUOMFactor = parseFloat(formData.PkgToItmUOMFactor);

        let calculatedPkgPricePerPkgUOM = 0.0000;
        let calculatedPkgPricePerItmUOM = 0.0000;

        if (!isNaN(currentPrice) && currentPrice > 0 && !isNaN(currentQty) && currentQty > 0) {
            calculatedPkgPricePerPkgUOM = (currentPrice / currentQty);
            if (!isNaN(currentUOMFactor) && currentUOMFactor > 0) {
                calculatedPkgPricePerItmUOM = calculatedPkgPricePerPkgUOM * currentUOMFactor;
            }
        }
        setPkgPricePerPkgUOM(parseFloat(calculatedPkgPricePerPkgUOM.toFixed(4)));
        setPkgPricePerItmUOM(parseFloat(calculatedPkgPricePerItmUOM.toFixed(4)));

        setGeneratedRecordNameError(null); // Clear error when derived values change
    }, [formData.Price, formData.PkgToItmUOMFactor, pkgQty, constructItnVrntPkgSupplierRecordName]);


    useEffect(() => {
        const fetchData = async () => {
            if (!tenantId) {
                setError("Tenant ID missing.");
                setLoading(false);
                return;
            }

            setLoading(true);
            setError(null);
            setItmVrntPkgNameError(null);
            setSupplierCodeError(null);

            try {
                const token = await auth.getIdToken();
                if (!token) {
                    setError("Authentication required. Please log in.");
                    setLoading(false);
                    return;
                }

                // Fetch active item variant packages for the dropdown
                // const itemVariantPackageResponse = await itemVariantPackageService.getAllActiveItemVariantsForDropdown(tenantId, token);
                // const itemVariantsResponse = await itemVariantsService.getAllActiveItemVariantsForDropdown(tenantId, token);
                // const itemVariantPackageResponse = await itemVariantsService.getAllActiveItemVariantsForDropdown(tenantId, token);
                const itemVariantPackageResponse = await itemVariantPackageService.listActiveItemVariantPackageNames(tenantId, token);
                if (itemVariantPackageResponse && itemVariantPackageResponse.packages) {
                    setItemVariantPackageOptions(itemVariantPackageResponse.packages.map(pkg => ({
                        name: pkg.itemVariantPackageName,
                        qty: pkg.QTY,
                        uom: pkg.UOM,
                        chefsRating: pkg.ChefsRating,
                        chefsNotes: pkg.ChefsNotes,
                        id: pkg.id,
                        sku: pkg.SKU, // NEW ver 01: SKU for autoselection
                        upc: pkg.UPC, // NEW ver 01: UPC for autoselection
                    })));
                } else {
                    setItmVrntPkgNameError("Failed to load active item variant packages for dropdown.");
                }


                // Fetch active supplier codes for the dropdown
                const suppliersResponse = await supplierService.getAllActiveSupplierCodesForDropdown(tenantId, token);
                if (suppliersResponse && suppliersResponse.suppliers) {
                    setSupplierCodeOptions(suppliersResponse.suppliers.map(sup => ({
                        code: sup.supplierCode,
                        name: sup.companyName,
                        id: sup.id,
                    })));
                } else {
                    setSupplierCodeError("Failed to load active supplier codes for dropdown.");
                }


                if (isEditing || isShowingDetails) {
                    const data = await itmVrntPkgSuplrsPriceService.getItmVrntPkgSuplrsPriceById(tenantId, itmVrntPkgSupPriceId, token);
                    if (data) {
                        setFormData(data);
                        setOriginalPrice(data.Price); // NEW ver 01: Store original price
                        setOriginalUOMFactor(data.PkgToItmUOMFactor); // NEW ver 01a: Store original UOM Factor
                        // Set dependent states from fetched data
                        setPkgQty(data.PkgQty);
                        setPkgUOM(data.PkgUOM);
                        setChefsRating(data.ChefsRating);
                        setChefsNotes(data.ChefsNotes);
                       setSKU(data.SKU); // NEW ver 01
                        setUPC(data.UPC); // NEW ver 01
                        setStatus(data.Status); // NEW ver 01
                        setIsDataCurrent(data.IsDataCurrent); // NEW ver 01

                        console.log(`pkgQty = ${pkgQty}`);
                        console.log(`pkgUOM = ${pkgUOM}`);

                        if (data.DateEntered && data.DateEntered._seconds) data.DateEntered = new Date(data.DateEntered._seconds * 1000);
                        if (data.DateSamePriceConfirmed && data.DateSamePriceConfirmed._seconds) data.DateSamePriceConfirmed = new Date(data.DateSamePriceConfirmed._seconds * 1000);
                        if (data.DateLastModified && data.DateLastModified._seconds) data.DateLastModified = new Date(data.DateLastModified._seconds * 1000);
                    } else {
                        setError("Item Variant Package Supplier Price record not found.");
                        navigate(`/itm-vrnt-pkg-suplrs-price`);
                    }
                } else { // For adding new record
                    // Set default ItemVariantPackageName and SupplierCode if options exist

                    console.log(`itemVariantPackageResponse.packages = ${itemVariantPackageResponse.packages}`);
                    console.log(`suppliersResponse.suppliers = ${suppliersResponse.suppliers}`);
                    console.log(`itemVariantPackageResponse.packages.length = ${itemVariantPackageResponse.packages.length}`);
                    console.log(`suppliersResponse.suppliers.length = ${suppliersResponse.suppliers.length}`);

                    if (itemVariantPackageResponse && itemVariantPackageResponse.packages.length > 0) {
                        const defaultPkg = itemVariantPackageResponse.packages[0];
                        setFormData(prev => ({
                            ...prev,
                            ItemVariantName: defaultPkg.name,
                            // Derived fields from default package
                            ChefsRating: defaultPkg.chefsRating,
                            ChefsNotes: defaultPkg.chefsNotes,
                        }));
                        setPkgQty(defaultPkg.qty);
                        setPkgUOM(defaultPkg.uom);
                        setChefsRating(defaultPkg.chefsRating);
                        setChefsNotes(defaultPkg.chefsNotes);
                        setSKU(defaultPkg.sku); // NEW ver 01
                        setUPC(defaultPkg.upc); // NEW ver 01
                    }
                    if (suppliersResponse && suppliersResponse.suppliers.length > 0) {
                        const defaultSupplier = suppliersResponse.suppliers[0];
                        setFormData(prev => ({
                            ...prev,
                            SupplierCode: defaultSupplier.code,
                        }));
                    }
                }
            } catch (err) {
                console.error("Error fetching data for form:", err);
                setError(`Failed to load data: ${err.message}`);
                setItmVrntPkgNameError(`Failed to load item variant packages: ${err.message}`);
                setSupplierCodeError(`Failed to load suppliers: ${err.message}`);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [tenantId, itmVrntPkgSupPriceId, isAdding, isEditing, isShowingDetails, navigate, auth, constructItnVrntPkgSupplierRecordName]);


    const handleChange = (e) => {

        console.log(`handleChange triggered for ${e.target.name} with value ${e.target.value}`);
        console.log(`isShowingDetails = ${isShowingDetails}, isEditingPrice = ${isEditingPrice}`);

        if (isShowingDetails && !isEditingPrice) return; // NEW ver 01c: Allow changes only if in ADD mode, or if in DETAILS mode and switching to EDIT_PRICE mode // NEW ver 01a: Prevent changes unless in isEditing price mode

        const { name, value } = e.target;
        
        if (name === 'ItemVariantName') {
            const selectedPkg = itemVariantPackageOptions.find(opt => opt.name === value);
            setFormData(prev => ({
                ...prev,
                [name]: value,
            }));
            // Update derived fields from selected package
            if (selectedPkg) {
                setPkgQty(selectedPkg.qty);
                setPkgUOM(selectedPkg.uom);
                setChefsRating(selectedPkg.chefsRating);
                setChefsNotes(selectedPkg.chefsNotes);
                setSKU(selectedPkg.sku); // NEW ver 01
                setUPC(selectedPkg.upc); // NEW ver 01
                setStatus(selectedPkg.status || 'Active'); // Default from variant package or to 'Active' NEW ver 01
                setIsDataCurrent(true); // Always true for new or updated price record NEW ver 01
            } else { // If selection is cleared or invalid
                setPkgQty(0);
                setPkgUOM('');
                setChefsRating('3-Good quality'); // Reset to default
                setChefsNotes('');
                setSKU(''); // NEW ver 01
                setUPC(''); // NEW ver 01
                setStatus('Active');
                setIsDataCurrent(true);
             }
        } else if (name === 'Price' || name === 'PkgToItmUOMFactor') {
            const floatValue = parseFloat(value);
            setFormData(prev => ({ ...prev, [name]: isNaN(floatValue) ? value : floatValue }));
            if (name === 'Price') {
                if (!isNaN(floatValue) && floatValue <= 0) setPriceError("Price must be > 0.");
                else if (isNaN(floatValue) && value !== '') setPriceError("Price must be a number.");
                else setPriceError(null);
            } else if (name === 'PkgToItmUOMFactor') {
                 if (!isNaN(floatValue) && floatValue <= 0) setUomFactorError("Factor must be > 0.");
                 else if (isNaN(floatValue) && value !== '') setUomFactorError("Factor must be a number.");
                 else setUomFactorError(null);
            }
        }
        // else if (name === 'SKU' || name === 'UPC') {   // NEW ver 1: Block removed UPC SKU not needed here
        //      setFormData(prev => ({ ...prev, [name]: value }));
        //      if (name === 'SKU' && value.trim() === '') setSkuError("SKU required.");
        //      else if (name === 'UPC' && (value.length !== 12 || !/^\d+$/.test(value))) setUpcError("UPC must be 12 digits.");
        //      else if (name === 'SKU') setSkuError(null);
        //      else if (name === 'UPC') setUpcError(null);
        // }
         else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handlePriceUpdateClick = async () => { // NEW ver 01: Handler for the "Price Update" button
        if (!canEdit) {
            alert("You do not have permission to update prices.");
            return;
        }

        // NEW ver 01a: Enter "Edit Price" mode
        setIsEditingPrice(true);
        console.log("Entered price edit mode. IsEditingPrice =", isEditingPrice);
        // We don't save yet, just enable the fields
    };

    const handleConfirmPriceUpdate = async () => { // NEW ver 01a: Triggered by "Confirm Update" button
        if (!canEdit) {
            alert("You do not have permission to update prices.");
            return;
        }

        const newPrice = parseFloat(formData.Price);
        const newUOMFactor = parseFloat(formData.PkgToItmUOMFactor);

        console.log(`Original Price: ${originalPrice}, New Price: ${newPrice}`);
        console.log(`New PkgToItmUOMFactor: ${newUOMFactor}`);

        // Frontend validation
        if (isNaN(newPrice) || newPrice <= 0 || parseFloat(newPrice.toFixed(2)) !== newPrice) {
            alert("Please enter a valid price greater than 0 with up to 2 decimal places.");
            setPriceError("Price must be a number greater than 0 with up to 2 decimal places.");
            return;
        }


        if (isNaN(newUOMFactor) || newUOMFactor <= 0) {
            alert("Please enter a valid PkgToItmUOMFactor greater than 0.");
            setUomFactorError("PkgToItmUOMFactor must be a number greater than 0.");
            return;
        }

        // Compare with original price (stored in originalPrice state)
        if (newPrice === originalPrice && newUOMFactor === originalUOMFactor) { // NEW: Compare both price and factor
            alert("No price or UOM factor change detected. Edit operation cancelled.");
            setIsEditingPrice(false); // Exit edit mode
            // Optionally, reset form to original data or navigate back
            // navigate(`/itm-vrnt-pkg-suplrs-price/details/${tenantId}/${itmVrntPkgSupPriceId}`);
            return;
        }

        const confirmProceed = window.confirm(
            `Price change detected!\n` +
            `Previous Price: ${originalPrice.toFixed(2)}\n` +
            `New Price: ${newPrice.toFixed(2)}\n\n` +
            `Proceed with price update? This will deactivate the old record and create a new one.`
        );

        if (!confirmProceed) {
            alert("Price update cancelled by user.");
            // Optionally, reset form to original data or navigate back
            // navigate(`/itm-vrnt-pkg-suplrs-price/details/${tenantId}/${itmVrntPkgSupPriceId}`);
            return;
        }

        try {
            const token = await auth.getIdToken();
            if (!token) {
                setError("Authentication required. Please log in.");
                return;
            }

            // Only send Price and PkgToItmUOMFactor for update
            const payload = {
                Price: newPrice,
                PkgToItmUOMFactor: newUOMFactor,
                // Other fields are system-managed on the backend for this type of update
            };

            const response = await itmVrntPkgSuplrsPriceService.updateItmVrntPkgSuplrsPrice(tenantId, itmVrntPkgSupPriceId, payload, token);
            alert(response.message || "Price record updated successfully!"); // Backend sends custom message


            // NEW ver 01a: After successful update, navigate back to details mode (which will refetch)
            navigate(`/itm-vrnt-pkg-suplrs-price`); // Navigate to list to see changes
            setIsEditingPrice(false); // Exit edit mode
        } catch (err) {
            console.error("Error updating price record:", err);
            setError(`Failed to update price record: ${err.message}`);
        }
    };

    const handleCancelPriceEdit = () => { // NEW ver 01a: Triggered by "Cancel" button
        setIsEditingPrice(false); // Exit edit mode
        // `useEffect` will re-fetch original data when mode changes
        // or you could manually reset formData here: setFormData(originalFetchedData);
        // For now, simply navigating to details will implicitly reset by refetching.
        navigate(`/itm-vrnt-pkg-suplrs-price/details/${itmVrntPkgSupPriceId}`);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setGeneratedRecordNameError(null);
        setItmVrntPkgNameError(null);
        setSupplierCodeError(null);
        setPriceError(null);
        setUomFactorError(null);
        setSkuError(null);
        setUpcError(null);

        if (isShowingDetails || !canEdit) {
            setError("You do not have permission to perform this action.");
            return;
        }
        if (!tenantId) {
            setError("Tenant ID missing. Cannot save record.");
            return;
        }

        // --- Frontend Validation ---
        if (!formData.ItmVrntPkgName || formData.ItmVrntPkgName.trim() === '') {
            setItmVrntPkgNameError("Item Variant Package Name is required.");
            return;
        }
        if (!formData.SupplierCode || formData.SupplierCode.trim() === '') {
            setSupplierCodeError("Supplier Code is required.");
            return;
        }
        const currentPrice = parseFloat(formData.Price);
        if (isNaN(currentPrice) || currentPrice <= 0 || parseFloat(currentPrice.toFixed(2)) !== currentPrice) {
            setPriceError("Price must be a number greater than 0 with up to 2 decimal places.");
            return;
        }
        const currentUOMFactor = parseFloat(formData.PkgToItmUOMFactor);
        if (isNaN(currentUOMFactor) || currentUOMFactor <= 0) {
            setUomFactorError("PkgToItmUOMFactor must be a number greater than 0.");
            return;
        }
        // if (!formData.SKU || formData.SKU.trim() === '') {   // REMOVED ver 01: Block Removed
        //     setSkuError("SKU is required.");
        //     return;
        // }
        // if (!formData.UPC || formData.UPC.length !== 12 || !/^\d+$/.test(formData.UPC)) {
        //     setUpcError("UPC is required and must be a 12-digit string.");
        //     return;
        // }
        // No validation needed for Status, ChefsRating, ChefsNotes as they are derived/dropdowns
        // --- End Frontend Validation ---
        
        try {
            const token = await auth.getIdToken();
            if (!token) {
                setError("Authentication required. Please log in.");
                return;
            }

            const payload = { ...formData };
            payload.Price = parseFloat(payload.Price);
            payload.PkgToItmUOMFactor = parseFloat(payload.PkgToItmUOMFactor);
            // Frontend sends the client-calculated ItemVariantPackageName for backend re-validation
            payload.ItnVrntPkgSupplierRecordName = constructItnVrntPkgSupplierRecordName(payload.ItmVrntPkgName, payload.SupplierCode);

            // In add mode, PkgQty, PkgUOM, ChefsRating, ChefsNotes are derived from ItemVariantPackageName lookup
            // On update, these are copied from the original document and are not user-editable (handled by backend).


            if (isEditing) { // REMOVED ver 01: This block replaced with that one below
                await itmVrntPkgSuplrsPriceService.updateItmVrntPkgSuplrsPrice(tenantId, itmVrntPkgSupPriceId, payload, token);
                alert("Item Variant Package Supplier Price updated successfully!");
            } else {
                await itmVrntPkgSuplrsPriceService.addItmVrntPkgSuplrsPrice(tenantId, payload, token);
                alert("Item Variant Package Supplier Price created successfully!");
            }
            navigate(`/itm-vrnt-pkg-suplrs-price`);

            // await itmVrntPkgSuplrsPriceService.addItmVrntPkgSuplrsPrice(tenantId, payload, token);
            // alert("Item Variant Package Supplier Price created successfully!");
            // navigate(`/itm-vrnt-pkg-suplrs-price`);




        } catch (err) {
            console.error("Error saving record via Cloud Function:", err);
            if (err instanceof ApiError && err.status === 409) {
                if (err.message.includes('Item Variant Package Supplier Record Name')) setGeneratedRecordNameError(`Error: ${err.message}`);
                // else if (err.message.includes('SKU')) setSkuError(`Error: ${err.message}`);
                // else if (err.message.includes('UPC')) setUpcError(`Error: ${err.message}`);
                else setError(`Failed to save record: ${err.message}`);
            } else if (err instanceof ApiError && err.status === 400) {
                 // Catch validation errors from backend
                if (err.message.includes('Item Variant Package')) setItmVrntPkgNameError(`Error: ${err.message}`);
                else if (err.message.includes('Supplier')) setSupplierCodeError(`Error: ${err.message}`);
                else if (err.message.includes('Price')) setPriceError(`Error: ${err.message}`);
                else if (err.message.includes('PkgToItmUOMFactor')) setUomFactorError(`Error: ${err.message}`);
                else setError(`Failed to save record: ${err.message}`);
            } else {
                setError(`Failed to save record: ${err.message}`);
            }
        }

    };

    if (loading) return <p>Loading item variant package supplier price details...</p>;
    if (error) return <p style={{ color: 'red' }}>Error: {error}</p>;
    if (!tenantId) return <p className="container" style={{ color: 'red' }}>Error: Tenant ID is required to manage item variant package supplier prices.</p>;


    return (
        <div className="container form-container">
            <h2>
                {isAdding && 'Add New Item Variant Package Supplier Price (Tenant: '}
                {isEditing && `Edit Item Variant Package Supplier Price (Tenant: `}
                {isShowingDetails && `Item Variant Package Supplier Price Details (Tenant: `}
                {tenantId})
            </h2>
            {!canEdit && (isEditing || isAdding || isShowingDetails || isEditingPrice) && ( // NEW ver 01a: Include isEditingPrice here
                <p style={{ color: 'orange', marginBottom: '1rem' }}>You are viewing this record in read-only mode. Contact an administrator to gain editing permissions.</p>
            )}
            <form onSubmit={handleSubmit}>
                {(isEditing || isShowingDetails || isEditingPrice) && formData.ItmVrntPkgSupSeqId && ( // NEW ver 01a: Include isEditingPrice
                    <div className="form-group">
                        <label>Sequential ID</label>
                        <input type="text" name="ItmVrntPkgSupSeqId" value={formData.ItmVrntPkgSupSeqId || ''} disabled />
                    </div>
                )}
                
                <div className="form-group">
                    <label>Item Package</label>
                    <select
                        name="ItmVrntPkgName"
                        value={formData.ItmVrntPkgName}
                        onChange={handleChange}
                        required
                        // disabled={isShowingDetails || !canEdit || (itemVariantPackageOptions.length === 0 && !itemVariantLookupError && loading)}
                        disabled={isShowingDetails || isEditingPrice || !canEdit || (itemVariantPackageOptions.length === 0 && !itmVrntPkgNameError && loading)} // NEW ver 01a: Disable during price edit //  FIXED NEW ver 01b: use itmVrntPkgNameError
                    >
                        <option value="">-- Select an Item Variant Package --</option>
                        {itemVariantPackageOptions.map(pkg => (
                            <option key={pkg.id} value={pkg.name}>{pkg.name}</option>
                        ))}
                    </select>
                    {itmVrntPkgNameError && <p style={{ color: 'red', fontSize: '0.85em' }}>{itmVrntPkgNameError}</p>}
                </div>

                <div className="form-group">
                    <label>Supplier Code</label>
                    <select
                        name="SupplierCode"
                        value={formData.SupplierCode}
                        onChange={handleChange}
                        required
                        disabled={isShowingDetails || isEditingPrice || !canEdit || (supplierCodeOptions.length === 0 && !supplierCodeError && loading)} // NEW ver 01a: Disable during price edit
                    >
                        <option value="">-- Select a Supplier --</option>
                        {supplierCodeOptions.map(sup => (
                            <option key={sup.id} value={sup.code}>{sup.code} - {sup.name}</option>
                        ))}
                    </select>
                    {supplierCodeError && <p style={{ color: 'red', fontSize: '0.85em' }}>{supplierCodeError}</p>}
                </div>

                <div className="form-group">
                    <label>Price</label>
                    <input
                        type="number"
                        step="0.01"
                        name="Price"
                        value={formData.Price}
                        onChange={handleChange}
                        required
                         disabled={isShowingDetails && !isEditingPrice || !canEdit && !isEditingPrice} // NEW ver 01a: Enabled only if isEditingPrice
                    />
                    {priceError && <p style={{ color: 'red', fontSize: '0.85em' }}>{priceError}</p>}
                </div>

                <div className="form-group">
                    <label>PkgQty</label>
                    {/* <input type="text" name="PkgQty" value={pkgQty.toFixed(2)} disabled /> Display only */}
                    <input type="text" name="PkgQty" value={pkgQty} disabled />  {/* Display only */}
                </div>

                <div className="form-group">
                    <label>PkgUOM</label>
                    <input type="text" name="PkgUOM" value={pkgUOM} disabled /> {/* Display only */}
                </div>

                <div className="form-group">
                    <label>PkgToItmUOMFactor</label>
                    <input
                        type="number"
                        step="0.01"
                        name="PkgToItmUOMFactor"
                        value={formData.PkgToItmUOMFactor}
                        onChange={handleChange}
                        required
                        disabled={isShowingDetails && !isEditingPrice || !canEdit && !isEditingPrice} // NEW ver 01a: Enabled only if isEditingPrice
                   />
                     {uomFactorError && <p style={{ color: 'red', fontSize: '0.85em' }}>{uomFactorError}</p>}
                </div>

                <div className="form-group">
                    <label>Prc/PkUOM</label>
                    <input type="text" name="PkgPricePerPkgUOM" value={pkgPricePerPkgUOM.toFixed(4)} disabled /> {/* Display only */}
                </div>

                <div className="form-group">
                    <label>StdPc/UOM</label>
                    <input type="text" name="PkgPricePerItmUOM" value={pkgPricePerItmUOM.toFixed(4)} disabled /> {/* Display only */}
                </div>

                <div className="form-group">
                    <label>VrtPkgSuplRecNm</label> {/* Auto-generated and disabled */}
                    <input type="text" name="ItnVrntPkgSupplierRecordName" value={constructItnVrntPkgSupplierRecordName(formData.ItmVrntPkgName, formData.SupplierCode) || ''} disabled />
                    {generatedRecordNameError && <p style={{ color: 'red', fontSize: '0.85em' }}>{generatedRecordNameError}</p>}
                </div>

                <div className="form-group">
                    <label>SKU</label>
                    {/* <input type="text" name="SKU" value={formData.SKU} onChange={handleChange} required disabled={isShowingDetails || !canEdit} />
                    {skuError && <p style={{ color: 'red', fontSize: '0.85em' }}>{skuError}</p>} */}
                    <input type="text" name="SKU" value={sku} disabled /> {/* Display only, from ItemVariantPackage */}

                </div>

                <div className="form-group">
                    <label>UPC</label>
                    {/* <input type="text" name="UPC" value={formData.UPC} onChange={handleChange} required disabled={isShowingDetails || !canEdit} />
                    {upcError && <p style={{ color: 'red', fontSize: '0.85em' }}>{upcError}</p>} */}
                    <input type="text" name="UPC" value={upc} disabled /> {/* Display only, from ItemVariantPackage */}
                </div>

                 <div className="form-group">
                    <label>Chefs Rating</label>
                    <input type="text" name="ChefsRating" value={chefsRating} disabled /> {/* Display only */}
                </div>

                <div className="form-group">
                    <label>Chefs Notes</label>
                    <textarea name="ChefsNotes" value={chefsNotes} rows="3" disabled></textarea> {/* Display only */}
                </div>

                <div className="form-group">
                    <label>Status</label>
                    <input type="text" name="Status" value={formData.Status} disabled /> {/* Display only */}
                </div>


                {(isEditing || isShowingDetails || isEditingPrice) && formData.DateEntered && ( // NEW ver 01a: Include isEditingPrice
                    <div className="form-group">
                        <label>Date Entered</label>
                        <input type="text" value={formData.DateEntered instanceof Date ? formData.DateEntered.toLocaleString() : new Date(formData.DateEntered._seconds * 1000).toLocaleString()} disabled />
                    </div>
                )}
                {(isEditing || isShowingDetails || isEditingPrice) && formData.DateSamePriceConfirmed && ( // NEW ver 01a: Include isEditingPrice
                    <div className="form-group">
                        <label>Date Same Price Confirmed</label>
                        <input type="text" value={formData.DateSamePriceConfirmed instanceof Date ? formData.DateSamePriceConfirmed.toLocaleString() : new Date(formData.DateSamePriceConfirmed._seconds * 1000).toLocaleString()} disabled />
                    </div>
                )}
                 {(isEditing || isShowingDetails || isEditingPrice) && formData.DateLastModified && ( // NEW ver 01a: Include isEditingPrice
                    <div className="form-group">
                        <label>Date Last Modified</label>
                        <input type="text" value={formData.DateLastModified instanceof Date ? formData.DateLastModified.toLocaleString() : new Date(formData.DateLastModified._seconds * 1000).toLocaleString()} disabled />
                    </div>
                )}
                 {(isEditing || isShowingDetails || isEditingPrice) && typeof formData.IsDataCurrent === 'boolean' && ( // NEW ver 01a: Include isEditingPrice
                    <div className="form-group">
                        <label>Is Data Current</label>
                        <input type="text" value={formData.IsDataCurrent ? 'Yes' : 'No'} disabled />
                    </div>
                )}


                {isShowingDetails && !isEditingPrice && ( // Only in details mode
                    <button type="button" className="danger" onClick={handlePriceUpdateClick}>
                        Price Update
                    </button>
                )}
                {isEditingPrice && canEdit && ( // NEW ver 01a: Show "Confirm Update" and "Cancel" buttons in price edit mode
                    <>
                        <button type="button" className="btn secondary" onClick={handleConfirmPriceUpdate} style={{ marginRight: '1rem' }}>
                            Confirm Update
                        </button>
                        <button type="button" className="danger" onClick={handleCancelPriceEdit}>
                            Cancel
                        </button>
                    </>
                )}

                {isAdding && canEdit && ( // NEW ver 01a: Blue Save button in add/edit mode if user can edit
                    <button type="submit">Save Record</button>
                )}



            </form>
        </div>
    );

}

export default ItmVrntPkgSuplrsPriceForm;